/****************************************************************IMPORTS*/
/****************************************NPM MODULES*/
import React from 'react';
import ReactDOM from 'react-dom/client';
/****************************************************/

/*********************************************STYLES*/
import './styles/index.css';
/****************************************************/

/*****************************************COMPONENTS*/
import { App } from './App';
/****************************************************/
/************************************************************************/


/*******************************************************************ROOT*/
const root: ReactDOM.Root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<React.StrictMode><App /></React.StrictMode>);
/************************************************************************/